import { useToasts } from 'react-toast-notifications';
import { useMutation } from '@apollo/react-hooks';
import { useHistory } from 'react-router';

import { UNAUTHENTICATE_CUSTOMER } from './queries';
import { routes } from '../../constants';

const useLogout = () => {
  const { addToast } = useToasts();
  const history = useHistory();

  const deleteTokenAndLogout = (client) => {
    // clear apollo cache
    history.push(routes.login.pathname);
    localStorage.clear();
    client.resetStore();
  };

  const [runMutation, { loading, client }] = useMutation(UNAUTHENTICATE_CUSTOMER, {
    onCompleted: () => deleteTokenAndLogout(client),
    onError: (err) => {
      console.log(err);

      addToast('Something unexpected happened, Try Again later', {
        appearance: 'error',
        autoDismiss: true,
      });
      deleteTokenAndLogout();
    },
  });

  const logout = (e) => {
    if (e) e.preventDefault();

    runMutation();
  };

  return {
    logout,
    loading,
  };
};

export default useLogout;
